import { f7 } from 'framework7-react';
import { FC, useEffect, useState } from 'react';
import { EmailDuplicated } from './EmailDuplicated/EmailDuplicated';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { useMultipleAffiliateInfo } from '@/hooks/api/auth/useMultipleAffiliateInfo';
import { MultipleAffiliateInfoApiParams, Affiliate } from '@/types/api/authApi';
import { getAffiliateIdFromThemeId } from '@/utils/shop';
import { switchCustomerAuth } from '@/utils/switchCustomerAuth';

interface EmailDuplicatedPageProps {
  affiliates?: Affiliate[];
}

export const EmailDuplicatedPage: FC<EmailDuplicatedPageProps> = ({
  affiliates,
}) => {
  const [customers, setCustomers] = useState<Affiliate[]>([]);
  const [customer, setCustomer] = useState<Affiliate | null | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getMultipleAffiliateInfo, data } = useMultipleAffiliateInfo();
  useEffect(() => {
    if (affiliates && affiliates.length > 0) {
      setCustomers(affiliates);
    } else {
      let parameter = '';
      if (store.state.loginInfo?.loginType === 'email') {
        parameter = store.state.loginInfo?.email || '';
      }
      if (store.state.loginInfo?.loginType === 'telephone') {
        parameter = store.state.loginInfo?.tel || '';
      }
      const params: MultipleAffiliateInfoApiParams = {
        parameter,
      };
      getMultipleAffiliateInfo(params);
    }
  }, []);

  useEffect(() => {
    if (data?.m_customers) {
      const globalTheme = store.state.globalTheme;
      if (globalTheme != null) {
        const currentAffiliate = data.m_customers.find(
          (customer) =>
            customer.m_affiliate_id === getAffiliateIdFromThemeId(globalTheme),
        );
        if (currentAffiliate) {
          setCustomers(
            data.m_customers.filter(
              (affiliate) =>
                affiliate.affiliate_app_type ===
                currentAffiliate.affiliate_app_type,
            ),
          );
          return;
        }
      }
      setCustomers(data.m_customers);
    }
  }, [data]);

  const handleClickChange = (customerData: Affiliate) => {
    setCustomer(customerData);
  };

  const handleClickSubmit = async () => {
    if (!customer || isSubmitting) return;
    try {
      setIsSubmitting(true);
      await switchCustomerAuth(customer.id);
      const router = f7.views.main.router;
      const navigateHome = () => {
        router.navigate(paths.home, {
          animate: false,
        });
      };
      const navigateWhenRouterIsReady = () => {
        if (router.allowPageChange) {
          navigateHome();
          return;
        }
        window.requestAnimationFrame(navigateWhenRouterIsReady);
      };
      navigateWhenRouterIsReady();
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'ログインに失敗しました';
      f7.dialog.alert(errorMessage, 'エラー');
      setIsSubmitting(false);
    }
  };
  return (
    <EmailDuplicated
      customers={customers}
      customer={customer}
      handleClickChange={handleClickChange}
      handleClickSubmit={handleClickSubmit}
      isSubmitting={isSubmitting}
    />
  );
};
